import React from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useStaticOptions } from "../context/StaticOptionsContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useOrderSave } from "../context/OrderSaveContext";
import { showErrorToast } from "../components/toasts/ToastService";

const KeregTipus = () => {
    const { order, updateOrder } = useOrder();
    const { staticOptions } = useStaticOptions();
    const navigate = useStepNavigate();
    const { saveOrder } = useOrderSave();
    const [loading, setLoading] = React.useState(false);

    const rindOptions = Array.isArray(staticOptions?.rind_options) ? staticOptions.rind_options : [];

    const handleOptionClick = (side, option) => {
        const updatedOrder = {
            ...order,
            hmeliorder: {
                ...order.hmeliorder,
            hmeliorder_rind_material: side === "rind_material" ? option.value : order.hmeliorder?.hmeliorder_rind_material || "",
            hmeliorder_rind_type: side === "rind_type" ? option.value : order.hmeliorder?.hmeliorder_rind_type || ""
            },
        };
        updateOrder(updatedOrder);
    };

    const handleNext = async () => {
        const selectedMaterial = order.hmeliorder?.hmeliorder_rind_material || "";
        const selectedType = order.hmeliorder?.hmeliorder_rind_type || "";

        if (!selectedMaterial || !selectedType) {
            showErrorToast("Kérem, válassza ki mindkét láb kéreg típusát!");
            return;
        }

        try {
            setLoading(true);
            const result = await saveOrder(order);

            if (result?.success !== false) {
                navigate("/OrrMerevito");
            } else {
                showErrorToast(result?.message || "Hiba történt a rendelés mentése során!");
            }
        } catch (err) {
            showErrorToast("Hiba történt a rendelés mentése során: " + (err?.message || err));
        } finally {
            setLoading(false);
        }
    };

    const renderOptions = (side, selectedOption, title) => (
        <div className="col-md-6 mb-4">
            <h6 className="fw-bold mb-3 text-center">{title}</h6>
            {rindOptions.length === 0 ? (
                <div className="alert alert-warning text-center">
                    Nem érhető el kéreg opció. Kérjük, próbálja meg később!
                </div>
            ) : (
                <div className="row g-2">
                    {rindOptions.map((option) => (
                        <div className="col-12" key={`${title}-${option.value}`}>
                            <button
                                type="button"
                                className={`btn w-100 py-3 px-2 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold
                                    ${selectedOption === option.value
                                        ? "btn-primary text-white"
                                        : "btn-outline-primary text-primary border-primary"
                                    }`}
                                style={{ fontSize: 18, fontWeight: 500, borderWidth: 2, minHeight: 80 }}
                                onClick={() => handleOptionClick(side, option)}
                                disabled={loading}
                            >
                                {option.label}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    const selectedMaterial = order.hmeliorder?.hmeliorder_rind_material || "";
    const selectedType = order.hmeliorder?.hmeliorder_rind_type || "";
    const canProceed = Boolean(selectedMaterial && selectedType);

    return (
        <TablerLayout title="Kéreg típus kiválasztása">
            <div className="row justify-content-center">
                {renderOptions("rind_material", selectedMaterial, "Bal láb")}
                {renderOptions("rind_type", selectedType, "Jobb láb")}
            </div>
            <div className="card-footer d-flex justify-content-between">
                <StepperNavButton
                    side="left"
                    label="Vissza"
                    onClick={() => navigate("/BelesTipus")}
                    disabled={loading}
                />
                <StepperNavButton
                    side="right"
                    label="Tovább"
                    onClick={handleNext}
                    disabled={!canProceed || loading}
                />
            </div>
        </TablerLayout>
    );
};

export default KeregTipus;